// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1Jtoy","row":"ProcedureTreatmentSummary_row__1RL6i"};